import { distance, fmtAgo, fmtDistance, fmtTime } from '../../../shared/units'
import type { Units } from '../../../shared/units'
import type { SavedPlace } from '../../store'
import type { WeatherReport } from '../../../shared/contract'

export function locationDetail(place: SavedPlace, units: Units): string {
  if (!place.isCurrent) return [place.region, place.zip].filter(Boolean).join(' · ')
  if (place.approximate) return 'Approximate area · from your network'
  if (place.accuracy_m == null) return 'Device location · accuracy unavailable'
  const radius = distance(place.accuracy_m, units.distance)
  const accuracy = radius != null && radius < .1 ? `accuracy <0.1 ${units.distance}` : `±${fmtDistance(place.accuracy_m, units.distance)}`
  return `${place.accuracy_m <= 150 ? 'Precise' : 'Approximate'} device location · ${accuracy}`
}

export function reportStamp(report: WeatherReport | undefined, offline: boolean, demo: boolean, units: Units): string {
  if (demo) return 'Demo · synthetic weather'
  if (!report) return offline ? 'Offline · no saved forecast' : 'Forecast not loaded'
  return `${offline ? 'Saved reading' : 'Reading'} · ${fmtAgo(report.current.time)} · ${fmtTime(report.current.time, report.location.timezone, units.clock)}`
}
